module.exports = __webpack_public_path__ + "img/multiAsset.c2ab635b.png";